import { useMemo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation } from "types/generated";
import { IntentProjectResourcesSuggestions } from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

import useCellCopyAction from "../useCellCopyAction";
import useCellFilterAction from "../useCellFilterAction";

const IntentProjectOperationsTableResourceIdCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const value = item.resourceID;
  const copyAction = useCellCopyAction({
    text: value,
  });

  const filterAction = useCellFilterAction({
    filterName: IntentProjectResourcesSuggestions.RESOURCE_ID,
    filterValue: value,
  });

  const actions = useMemo(() => [copyAction, filterAction], [copyAction, filterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellText>{value}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableResourceIdCell;
